import React from 'react';

const SharePurchaseAgreement: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 bg-gray-900 text-gray-100">
      <div className="text-center mb-8">
        <h1 className="text-3xl font-bold text-gold mb-2">SHARE PURCHASE AGREEMENT</h1>
        <p className="text-lg text-gray-300">Aureus Alliance Holdings (Pty) Ltd</p>
        <p className="text-sm text-white">Registration Number: 2025/368711/07</p>
      </div>

      <div className="space-y-6">
        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">1. Parties to the Agreement</h2>
          <div className="space-y-3">
            <p><strong>Company:</strong> Aureus Alliance Holdings (Pty) Ltd, a company duly incorporated under the laws of South Africa with registration number 2025/368711/07, having its registered address at 1848 Mees Avenue, Randpark Ridge, Randburg, Gauteng, 2169 ("the Company").</p>
            <p><strong>Purchaser:</strong> The individual or entity purchasing shares as identified during the registration and KYC process ("the Purchaser").</p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">2. Share Purchase Details</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">2.1 Share Type</h3>
            <p>The shares being purchased are ordinary shares with no par value in the Company, carrying equal rights to dividends and voting.</p>
            
            <h3 className="text-lg font-semibold text-white">2.2 Purchase Price</h3>
            <p>The purchase price per share shall be as determined by the Company's current pricing structure at the time of purchase, based on the active share phase.</p>
            
            <h3 className="text-lg font-semibold text-white">2.3 Payment Terms</h3>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Payment must be made in full before share allocation</li>
              <li>Accepted payment methods: USDT cryptocurrency or South African bank transfer</li>
              <li>All payments are subject to verification and approval</li>
              <li>Refunds are subject to Company policy and applicable law</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">3. Share Certificate and Registration</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">3.1 CIPC Registration</h3>
            <p>Share certificates will be processed and registered with the Companies and Intellectual Property Commission (CIPC) within 10-14 business days after:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Payment verification and approval</li>
              <li>Completion of KYC (Know Your Customer) requirements</li>
              <li>Approval of KYC documentation by the Company</li>
            </ul>
            
            <h3 className="text-lg font-semibold text-white">3.2 Certificate Details</h3>
            <p>The share certificate will contain:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Purchaser's full name, ID number, and address</li>
              <li>Aureus ID number assigned by the Company</li>
              <li>Share type: "ORDINARY PAR VALUE SHARES - $1,000 PER SHARE"</li>
              <li>Share range and total number of shares</li>
              <li>Purchase/issued date</li>
              <li>Certificate number</li>
              <li>Total amount of shares purchased</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">4. Dividend Rights and Distribution</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">4.1 Profit Sharing Guarantee</h3>
            <p>All shareholders are guaranteed to receive their proportional share of company profits generated from mining operations and other business ventures. However, the amount of dividends will vary based on actual company performance and profitability.</p>
            
            <h3 className="text-lg font-semibold text-white">4.2 Dividend Calculation</h3>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Dividends are calculated according to actual company profit after all operational expenses</li>
              <li>Each shareholder receives dividends proportional to their shareholding percentage</li>
              <li>Dividend amounts will vary based on company performance</li>
              <li>There are no guaranteed percentage-based returns on share ownership</li>
              <li>Dividend declarations and timing are at the discretion of the Board of Directors</li>
            </ul>
            
            <h3 className="text-lg font-semibold text-white">4.3 Distribution Method</h3>
            <p>Dividends will be distributed through the Company's digital platform or other methods as determined by the Company.</p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">5. Shareholder Rights and Obligations</h2>
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">5.1 Rights</h3>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Right to receive proportional dividends from company profits</li>
              <li>Right to vote on matters requiring shareholder approval</li>
              <li>Right to access company information as provided by law</li>
              <li>Right to transfer shares subject to Company approval and applicable restrictions</li>
            </ul>
            
            <h3 className="text-lg font-semibold text-white">5.2 Obligations</h3>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Comply with all Company policies and procedures</li>
              <li>Maintain accurate and up-to-date contact information</li>
              <li>Complete KYC requirements as requested</li>
              <li>Pay all applicable taxes on dividends received</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">6. Risk Acknowledgment</h2>
          <div className="space-y-3">
            <p>The Purchaser acknowledges and accepts the following risks:</p>
            <ul className="list-disc list-inside ml-4 space-y-1 text-sm">
              <li>Mining operations involve significant operational, environmental, and regulatory risks</li>
              <li>Gold prices and currency fluctuations may affect company profitability</li>
              <li>Dividend amounts will vary based on actual business performance</li>
              <li>There are no guaranteed returns or specific performance outcomes</li>
              <li>Shares may have limited liquidity and may not be easily sold</li>
              <li>Share value may fluctuate and could result in loss</li>
            </ul>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibent text-gold mb-4">7. Governing Law and Jurisdiction</h2>
          <div className="space-y-3">
            <p>This Agreement shall be governed by and construed in accordance with the laws of South Africa. Any disputes arising from this Agreement shall be subject to the exclusive jurisdiction of the South African courts.</p>
          </div>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-gold mb-4">8. Company Information</h2>
          <div className="space-y-2">
            <p><strong>Aureus Alliance Holdings (Pty) Ltd</strong></p>
            <p><strong>Registration Number:</strong> 2025/368711/07</p>
            <p><strong>Registered Address:</strong> 1848 Mees Avenue, Randpark Ridge, Randburg, Gauteng, 2169</p>
            <p><strong>General Inquiries:</strong> info@aureus.africa</p>
            <p><strong>Website:</strong> aureus.africa</p>
          </div>
        </section>

        <div className="border-t border-gray-600 pt-6 mt-8">
          <p className="text-sm text-white text-center">
            This Share Purchase Agreement constitutes a binding legal contract between the Purchaser and Aureus Alliance Holdings (Pty) Ltd.
            By purchasing shares, the Purchaser agrees to be bound by all terms and conditions set forth in this Agreement.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SharePurchaseAgreement;
